// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3855":"078f6fb6a8a04311","6409":"c5390f6f3c978440"}[chunkId] + ".css";
};